import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

export function EidAuthenticated() {
    const {t} = useTranslation();

    useEffect(() => {
        window.close();
    }, []);

    return (
        <main className='main-content' id='main'>
            <h1 className='main-content__header'>{t('eid_authenticated.header')}</h1>
            <p className='main-content__subheader'>{t('eid_authenticated.subheader')}</p>
        </main>
    );
}
